
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.325 1.8a1.925 1.925 0 00-2.65 0L.806 9.663l.888.887L3.125 9.12v7.756A1.875 1.875 0 005 18.75h10a1.875 1.875 0 001.875-1.875V9.12l1.431 1.431.888-.887L11.325 1.8zM8.75 17.5v-4.375h2.5V17.5h-2.5zm6.875-.625A.625.625 0 0115 17.5h-2.5v-5.625h-5V17.5H5a.625.625 0 01-.625-.625V7.87L9.556 2.68a.625.625 0 01.888 0l5.181 5.188v9.006z","fill":"#fff"}})])
          )
        }
      }
    